import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button } from 'components';

const Follow = ({
  id,
  size = 'xsmall',
  fit = false,
  disabled,
  text,
  callback,
}) => {
  const dispatch = useDispatch();
  const selected = useSelector((store) =>
    store.follows.data.find(
      (follow) => follow.followed_id === parseInt(id)
    )
  );
  const [status, setStatus] = useState(selected ? 'Success' : 'Idle');

  const update = (e) => {
    if (disabled) return;
    if (e) e.preventDefault();
    setStatus('Pending');
    dispatch.follows.update({ id, success: callback });
  };

  useEffect(() => {
    setStatus(selected ? 'Success' : 'Idle');
  }, [selected]);

  return (
    // <Container onClick={() => disabled ? false : metaKeyPress ? navigate('/follows') : sendFollow()}>
    <Button
      xsmall={size === 'xsmall'}
      small={size === 'small'}
      fit={fit}
      onClick={update}
      disabled={status === 'Pending'}
      outlined={status !== 'Success'}
    >
      <span style={{ display: 'inline-block', paddingTop: '2px' }}>
        {status === 'Success' ? 'Following' : 'Follow'}
      </span>
      {status !== 'Success' && (
        <span style={{ display: 'inline-block', marginLeft: '3px' }}>
          {' '}
          +
        </span>
      )}
    </Button>
  );
};

export default Follow;
